import React from "react";
import { Box, BoxProps } from "@mui/material";

export const Row: React.FC<BoxProps> = ({ children, sx, ...rest }) => (
  <Box display="flex" flexDirection="row" sx={{ width: "100%", maxWidth: "100%", ...sx }} {...rest}>
    {children}
  </Box>
);
